exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.donation-button {\n  display: inline-block;\n  padding: 5px 10px;\n  font-size: 16px;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  outline: none;\n  color: #fff;\n  background-color: #4CAF50;\n  border: none;\n  border-radius: 4px;\n  box-shadow: 0 1px #999; }\n\n.donation-button:hover {\n  background-color: #3e8e41; }\n\n.donation-button:active {\n  background-color: #3e8e41;\n  box-shadow: 0 2px #666;\n  transform: translateY(2px); }\n\np.don {\n  font-size: 18px;\n  text-align: center;\n  padding: 25px 0px;\n  /* display: block; */\n  width: 600px;\n  text-align: center;\n  margin: 0 auto;\n  line-height: 44px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!./src/styles.scss
// module id = 582
// module chunks = 11